interface Props {
    label: string;
}

export default function LefSideLabel({ label }: Props) {
    return (
        <div className="relative">
            <button
                type="button"
                disabled
                className="flex w-full items-start justify-between border-r bg-[#186cb2]/10 px-3 py-[8px] text-xs disabled:cursor-not-allowed"
            >
                <span className="flex-1 text-left font-semibold">
                    {label}
                </span>
            </button>
        </div>
    )
}
